(function () {
  const moveIndicator = (thumbsSlider) => {
    if (!thumbsSlider || !thumbsSlider.swiper) return;
    const activeSlide = thumbsSlider.querySelector(
      ".swiper-slide-thumb-active"
    );
    const indicatorEl = thumbsSlider.querySelector(
      ".tabs-slider-thumbs-indicator"
    );
    if (!activeSlide || !indicatorEl) return;

    const thumbsSwiper = thumbsSlider.swiper;

    const updateIndicatorPosition = () => {
      const wrapperTransform = thumbsSwiper.wrapperEl.style.transform;
      const match = wrapperTransform.match(/translate3d\((-?\d+\.?\d*)px/);
      const translateX = match ? parseFloat(match[1]) : 0;

      const indicatorWidth = activeSlide.offsetWidth;
      const indicatorLeft = activeSlide.offsetLeft + translateX;

      indicatorEl.style.width = `${indicatorWidth}px`;
      indicatorEl.style.left = `${indicatorLeft}px`;
    };

    requestAnimationFrame(() => updateIndicatorPosition());
  };

  const initThumbsSlider = (section) => {
    if (!section || !section?.classList.contains("tabs-slider-section")) return;

    const sliderEl = section.querySelector(".js-tabs-slider-thumbs");
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy();

    new Swiper(sliderEl, {
      loop: false,
      spaceBetween: 4,
      slidesPerView: "auto",
      freeMode: true,
      speed: 800,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      on: {
        init() {
          const parentEl = sliderEl.closest(".tabs-slider-thumbs");
          if (parentEl) {
            parentEl.classList.add("tabs-slider-thumbs-initialized");
          }

          moveIndicator(sliderEl);
        },
        slideChangeTransitionStart() {
          moveIndicator(sliderEl);
        },
        slideChangeTransitionEnd() {
          moveIndicator(sliderEl);
        },
        sliderMove() {
          moveIndicator(sliderEl);
        },
        slideChange() {
          moveIndicator(sliderEl);
        },
      },
    });
  };

  const initMainSlider = (section) => {
    if (!section || !section?.classList.contains("tabs-slider-section")) return;

    const sliderEl = section.querySelector(".js-tabs-slider-main");
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy();

    const animationType = sliderEl.dataset?.animationType || "slide";
    const nextBtn = section.querySelector(".slider-nav-button--next");
    const prevBtn = section.querySelector(".slider-nav-button--prev");
    const sliderLoop = sliderEl.getAttribute("data-loop") === "true";
    const hasSliderAutoplay = sliderEl.getAttribute("data-autoplay") === "true";
    const pauseAutoplayOnHover =
      sliderEl.getAttribute("data-autoplay-pause-on-hover") === "true";
    const autoplayDelay = Number(sliderEl.dataset.autoplayDelay || 5000);
    const hasParallax = sliderEl.getAttribute("data-parallax") === "true";

    const thumbsSlider = section.querySelector(".js-tabs-slider-thumbs");

    new Swiper(sliderEl, {
      loop: sliderLoop,
      slidesPerView: 1,
      spaceBetween: 12,
      speed: animationType === "creative" ? 1000 : 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      effect: animationType,
      creativeEffect:
        animationType === "creative"
          ? {
              prev: {
                shadow: true,
                translate: ["-20%", 0, -1],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            }
          : {},
      resistanceRatio: animationType === "creative" ? 0 : 0.85,
      parallax: hasParallax,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: hasSliderAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseAutoplayOnHover,
          }
        : false,
      pagination: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      thumbs: {
        swiper: thumbsSlider?.swiper ? thumbsSlider.swiper : "",
        autoScrollOffset: 1,
        multipleActiveThumbs: false,
        slideThumbActiveClass: "swiper-slide-thumb-active",
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
        },
      },
      on: {
        init() {
          if (thumbsSlider) {
            moveIndicator(thumbsSlider);
          }
        },
        autoplayTimeLeft(s, time, progress) {
          const indicatorEl = section.querySelector(
            ".tabs-slider-thumbs-indicator"
          );
          if (!thumbsSlider || !indicatorEl || !hasSliderAutoplay) return;

          if (s.autoplay.running) {
            indicatorEl.style.setProperty("--slider-progress", 1 - progress);
          }
        },
        slideChangeTransitionStart() {
          this.allowSlideNext = false;
          this.allowSlidePrev = false;
          this.allowTouchMove = false;

          if (thumbsSlider) {
            moveIndicator(thumbsSlider);
          }

          if (animationType === "creative") {
            const prevSlide = this.slides[this.previousIndex];
            const prevContent = prevSlide?.querySelector(
              ".tabs-slider-slide__content"
            );
            if (prevContent) {
              prevContent.style.transition = "opacity 0.3s ease";
              prevContent.style.opacity = "0";
            }
          }
        },
        slideChangeTransitionEnd() {
          this.allowSlideNext = true;
          this.allowSlidePrev = true;
          this.allowTouchMove = true;

          if (thumbsSlider) {
            moveIndicator(thumbsSlider);
          }

          if (animationType === "creative") {
            const prevSlide = this.slides[this.previousIndex];
            const prevContent = prevSlide?.querySelector(
              ".tabs-slider-slide__content"
            );
            if (prevContent) {
              prevContent.removeAttribute("style");
            }
          }
        },
      },
    });
  };

  const parentSection = document.currentScript.parentElement;
  initThumbsSlider(parentSection);
  initMainSlider(parentSection);

  document.addEventListener("shopify:section:load", function (event) {
    initThumbsSlider(event.target);
    initMainSlider(event.target);
  });
})();
